@file:OptIn(InternalResourceApi::class)

package chat.amp.tim.amp.chat.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.DrawableResource
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.ResourceItem

private const val MD: String = "composeResources/chat.amp.tim.amp.chat.generated.resources/"

internal val Res.drawable.CHERRY_Health_TIM_Logo: DrawableResource by lazy {
      DrawableResource("drawable:CHERRY_Health_TIM_Logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/CHERRY_Health_TIM-Logo.png", -1, -1),
      ))
    }

internal val Res.drawable.CHERRY_Logo_Claim: DrawableResource by lazy {
      DrawableResource("drawable:CHERRY_Logo_Claim", setOf(
        ResourceItem(setOf(), "${MD}drawable/CHERRY_Logo_Claim.png", -1, -1),
      ))
    }

internal val Res.drawable.CID_LO_Logo_Symbol_RGB_red_201203: DrawableResource by lazy {
      DrawableResource("drawable:CID_LO_Logo_Symbol_RGB_red_201203", setOf(
        ResourceItem(setOf(), "${MD}drawable/CID_LO_Logo_Symbol_RGB_red_201203.png", -1, -1),
      ))
    }

internal val Res.drawable.amp_logo: DrawableResource by lazy {
      DrawableResource("drawable:amp_logo", setOf(
        ResourceItem(setOf(), "${MD}drawable/amp_logo.svg", -1, -1),
      ))
    }

internal val Res.drawable.amp_logo_png: DrawableResource by lazy {
      DrawableResource("drawable:amp_logo_png", setOf(
        ResourceItem(setOf(), "${MD}drawable/amp_logo_png.png", -1, -1),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainDrawable0Resources(map: MutableMap<String, DrawableResource>) {
  map.put("CHERRY_Health_TIM_Logo", Res.drawable.CHERRY_Health_TIM_Logo)
  map.put("CHERRY_Logo_Claim", Res.drawable.CHERRY_Logo_Claim)
  map.put("CID_LO_Logo_Symbol_RGB_red_201203", Res.drawable.CID_LO_Logo_Symbol_RGB_red_201203)
  map.put("amp_logo", Res.drawable.amp_logo)
  map.put("amp_logo_png", Res.drawable.amp_logo_png)
}
